"use client";

import React from 'react';
import { MarketStructure } from "@/types/market-structure";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from "react-responsive";
import MarketStructureDesktop from "./Desktop/MarketStructureDesktop";
import MarketStructureMobile from "./Mobile/MarketStructureMobile";

const MarketStructureAnalysis = () => {
  const { t } = useTranslation('translation');
  const isMobile = useMediaQuery({ maxWidth: 768 });
  
  const structureData: MarketStructure[] = [
    {
      id: 1,
      name: "",
      designation: "",
      content: `${t('marketStructureTagline')}

${t('marketStructureDescription')}

${t('marketStructureFeatures')}
- ${t('marketStructureFeature1')}
- ${t('marketStructureFeature2')}
- ${t('marketStructureFeature3')}`,
      image: "/images/market-structure/analysis.png",
      star: 5,
    }
  ];

  const title = t('marketStructureTitle');

  return (
    <section className="dark:bg-bg-color-dark bg-gray-light relative z-10 py-16 md:py-20 lg:py-28">
      {isMobile ? (
        <MarketStructureMobile title={title} structureData={structureData} />
      ) : (
        <MarketStructureDesktop title={title} structureData={structureData} />
      )}
    </section>
  );
};

export default MarketStructureAnalysis; 